import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=33ecff70&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=ts"
export * from "./Documents.vue?vue&type=script&lang=ts"
import style0 from "./Documents.vue?vue&type=style&index=0&id=33ecff70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ecff70",
  null
  
)

export default component.exports